import React, { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import AboutBrand from "../components/AboutBrand";
import Products from "../components/Products";
import Benefits from "../components/Benefits";
import Stats from "../components/Stats";
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import { CartProvider } from "../context/CartContext";

const Home = () => {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("in")),
      { threshold: 0.12 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <CartProvider>
      <Header />
      <Hero />
      <AboutBrand />
      <Products />
      <Benefits />
      <Stats />
      <CTA />
      <Footer />
    </CartProvider>
  );
};

export default Home;
